(function () {
	'use strict';

	angular
        .module('app.dailyLogs')
        .factory('entryDialog', entryDialog);

    entryDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];

	/* @ngInject */
    function entryDialog($modal, $templateCache, opsIncludeVersion) {
		var service = {
			show: show
		};

		return service;

		function show(title, includeTemplate, logType, items) {
			var modalOptions = {
                templateUrl: "app/dialogs/_modalTemplateDialog.html?v=" + opsIncludeVersion,
				controller: ModalInstance,
				controllerAs: 'vm',
				keyboard: true,
				resolve: {
					options: function () {
						return {
							title: title,
							logType: logType,
							includeTemplate: includeTemplate,
                            items: items
						};
					}
				}
			};

			return $modal.open(modalOptions).result;
		}
	}

	ModalInstance.$inject = ['$uibModalInstance', 'options', 'dataservice', 'common', 'attachmentService'];

	/* @ngInject */
	function ModalInstance($modalInstance, options, dataservice, common, attachmentService) {
	    var vm = this;
	    vm.item = {};
	    vm.logType = options.logType;
	    vm.items = options.items;
		vm.isSaving = false;
		vm.title = options.title || 'Title';
		vm.okText = options.okText || 'OK';
		vm.cancelText = options.cancelText || 'Cancel';
		vm.includeTemplate = options.includeTemplate;
		
				
		vm.ok = function () {
		    if (vm.item.NewNote && vm.item.NewNote.trim() !== "") {
                
		        newEntry();
		    }
		    else {
		        var imgInput = document.getElementById("photo");
                
		        var img = imgInput.files[0];
            
		        if (img) {
		            common.logger.error("You must enter a note with your attachment");
		            return;
		        }
		    }
			$modalInstance.close('ok');
		};

		vm.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

	    function newEntry() {
			if (!(vm.item.NewNote) || vm.item.NewNote.trim() === "") {
				return;
			}
			vm.isSaving = true;
			var entryDto = {};
			entryDto.Entry = vm.item.NewNote;
			entryDto.DisplayOn = moment( common.getMainState("mainDate")).format("YYYY-MM-DD");
			entryDto.LogTypeId = vm.logType.ID;

			var parentType = "LogEntry";
			
	        dataservice.saveItem('api/DailyLogs/NewEntry', entryDto).then(function (saveResult) {
	            vm.isSaving = false;

				var savedEntry = saveResult.data;
                common.convertDateStringsToDates(savedEntry);
				attachmentService.upload(parentType, savedEntry.ID, savedEntry);
                
				vm.item.NewNote = "";
				//vm.items.push(savedEntry);
				/*vm.items.sort(function (a, b) {
					a = new Date(a.DateAddedUtc);
					b = new Date(b.DateAddedUtc);
					return a > b ? -1 : a < b ? 1 : 0
				});*/
			}).catch(function (error) {
				
			});

		}
	}
})();